import { useUpdateConfig } from '~/domains/configuration/mutations/updateConfig'
import { useConfig } from '~/domains/configuration/queries/config'

type Agency = { id: number; name: string }

export const useActiveAgency = () => {
  const configQuery = useConfig('agency.active_agency')
  const mutation = useUpdateConfig('agency.active_agency')

  const setActiveAgency = (agency: Agency) => {
    mutation.mutate({ value: agency })
  }

  return {
    activeAgency: configQuery.data ?? null,
    isLoading: configQuery.isLoading,
    setActiveAgency,
    mutation
  }
}
